import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "/home/runner/work/digital-chamada/digital-chamada/frontend/digital-chamada-frontend/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js";
import _createClass from "/home/runner/work/digital-chamada/digital-chamada/frontend/digital-chamada-frontend/node_modules/@babel/runtime-corejs2/helpers/createClass.js";
import _inherits from "/home/runner/work/digital-chamada/digital-chamada/frontend/digital-chamada-frontend/node_modules/@babel/runtime-corejs2/helpers/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/digital-chamada/digital-chamada/frontend/digital-chamada-frontend/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/digital-chamada/digital-chamada/frontend/digital-chamada-frontend/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import AxiosUtils from "../utils/AxiosUtils";
// import LocalStorage from 'quasar/src/plugins/LocalStorage.js';import SessionStorage from 'quasar/src/plugins/SessionStorage.js';;
var Service = /*#__PURE__*/function (_AxiosUtils) {
  _inherits(Service, _AxiosUtils);
  var _super = _createSuper(Service);
  function Service() {
    _classCallCheck(this, Service);
    return _super.apply(this, arguments);
  }
  _createClass(Service, [{
    key: "setInLocalStorage",
    value: function setInLocalStorage(key, value) {
      localStorage.set(key, value);
    }
  }, {
    key: "getFromLocalStorage",
    value: function getFromLocalStorage(key) {
      return localStorage.getItem(key);
    }
  }, {
    key: "setInSessionStorage",
    value: function setInSessionStorage(key, value) {
      sessionStorage.set(key, value);
    }
  }, {
    key: "getFromSessionStorage",
    value: function getFromSessionStorage(key) {
      return sessionStorage.getItem(key);
    }
  }, {
    key: "getVersion",
    value: function getVersion() {
      return this.getFromLocalStorage("version");
    }
  }, {
    key: "sair",
    value: function sair() {
      localStorage.clear();
    }
  }, {
    key: "getHeaders",
    value: function getHeaders() {
      return {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("painel-web-auth-token")
        }
      };
    }
  }]);
  return Service;
}(AxiosUtils);
export default Service;